import { StyledMintModalChoice } from './MintModalChoice.styled';

const MintModalChoice = ({ label = 'Or click below to mint brand new' }) => {
  return (
    <StyledMintModalChoice>
      <div className='mint-modal-divider-or'>{label}</div>
      <div className='mint-modal-divider'/>
    </StyledMintModalChoice>
  );
};

export default MintModalChoice;

